import { SITE_URL } from "./seo-constants";

type SanityImageRef = {
  asset: { url: string };
};

export type SchemaImage = {
  "@type": "ImageObject";
  url: string;
  width: number;
  height: number;
};

// Documents without a cover/hero image still need an `image` — Google's Article
// guidance treats it as required, so fall back to the site-wide OG asset.
export const FALLBACK_SCHEMA_IMAGES: SchemaImage[] = [
  { "@type": "ImageObject", url: `${SITE_URL}/og/default.png`, width: 1200, height: 630 },
];

// Google's Article guidance asks for 16:9, 4:3 and 1:1 crops, each >=1200px
// wide. This is a different surface from Open Graph (1.91:1) — the two must not
// share a crop, so `sanityOgImageUrl` below stays as it is.
const SCHEMA_RATIOS = [
  { w: 1200, h: 675 },
  { w: 1200, h: 900 },
  { w: 1200, h: 1200 },
];

export function schemaImages(image: SanityImageRef): SchemaImage[] {
  return SCHEMA_RATIOS.map(({ w, h }) => ({
    "@type": "ImageObject" as const,
    url: `${image.asset.url}?w=${w}&h=${h}&fit=crop&crop=focalpoint&fm=png&q=85`,
    width: w,
    height: h,
  }));
}

export function sanityOgImageUrl(image: SanityImageRef): {
  url: string;
  width: number;
  height: number;
  type: string;
} {
  const url = `${image.asset.url}?w=1200&h=630&fit=crop&crop=focalpoint&fm=png&q=85`;
  return { url, width: 1200, height: 630, type: "image/png" };
}
